import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconMessage2 } from "@tabler/icons-react";
import { useFeedbackWidgetHidden } from "@/hooks/useHideFeedbackWidget";
import { FeedbackModal } from "./FeedbackModal";

/**
 * Replaces the PostHog survey widget (ENG-616). Renders the "FEEDBACK" tab on
 * the right edge (desktop) or a floating pill above the tab bar (mobile), and
 * the feedback sheet it opens. Mounted once for every authenticated route.
 */
export const FeedbackWidget: React.FC = () => {
  const { t } = useTranslation();
  const hidden = useFeedbackWidgetHidden();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {!hidden && !isOpen && (
        <>
          {/* Desktop: vertical tab pinned to the right edge */}
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            aria-label={t("feedback.open_label")}
            className="fixed right-0 top-1/2 z-30 hidden -translate-y-1/2 rounded-l-[8px] bg-[var(--color-forest)] px-2.5 py-4 text-[14px] font-bold uppercase tracking-[0.14em] text-[var(--text-on-forest)] shadow-[0_4px_14px_rgba(12,61,45,0.22)] transition-colors hover:bg-[var(--color-forest-deep)] md:block"
            style={{
              writingMode: "vertical-rl",
              transform: "translateY(-50%)",
            }}
          >
            {t("feedback.tab_label")}
          </button>

          {/* Mobile: floating pill that clears the bottom tab bar */}
          <button
            type="button"
            onClick={() => setIsOpen(true)}
            aria-label={t("feedback.open_label")}
            className="fixed right-4 z-30 flex items-center gap-2 rounded-full bg-[var(--color-forest)] px-4 py-2.5 text-[14px] font-bold text-[var(--text-on-forest)] shadow-[0_4px_14px_rgba(12,61,45,0.22)] md:hidden"
            style={{ bottom: "calc(76px + env(safe-area-inset-bottom, 0px))" }}
          >
            <IconMessage2 size={18} aria-hidden="true" />
            {t("feedback.tab_label_mobile")}
          </button>
        </>
      )}
      <FeedbackModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FeedbackWidget;
